import Page from './sms.page.vue'

let routes = [
  {
    path: 'sms',
    name: 'sms',
    component: Page
  },
]

export default routes
